'use client';

import { motion } from 'framer-motion';
import { Code2, Smartphone, FileCode, Container, Cloud, GitBranch, Layers } from 'lucide-react';
import { JSX } from 'react';

// Definiere den Feature-Typ direkt
type Feature = {
  title: string;
  desc: string;
  iconName: IconName;
};

// Icon-Namen als Union Type
type IconName = 'frontend' | 'responsive' | 'standards' | 'docker' | 'cloud' | 'automation' | 'app-development';

interface HomeFeaturesProps {
  features: Feature[];
}

export function HomeFeatures({ features }: HomeFeaturesProps) {
  return (
    <motion.div
      className="flex align-center flex-wrap gap-6 mb-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 0.8 }}
    >
      {features.map((feature, index) => (
        <motion.div
          key={index}
          className="bg-[rgba(12,11,50,0.3)] md:max-w-md shrink grow basis-3xs backdrop-blur-sm p-6 rounded-xl border border-[#88ffff]/10"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.9 + (index * 0.2) }}
          whileHover={{ y: -5, transition: {delay: 0}, borderColor: 'rgba(136, 255, 255, 0.3)' }}
        >
          <div className="text-[#88ffff] mb-4">{getFeatureIcon(feature.iconName)}</div>
          <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
          <p className="text-white/70">{feature.desc}</p>
        </motion.div>
      ))}
    </motion.div>
  );
}

// Hilfsfunktion für Icons
function getFeatureIcon(name: IconName): JSX.Element {
  const icons: { [key in IconName]: JSX.Element } = {
    frontend: <Code2 size={24} />,
    responsive: <Smartphone size={24} />,
    standards: <FileCode size={24} />,
    docker: <Container size={24} />,
    cloud: <Cloud size={24} />,
    automation: <GitBranch size={24} />,
    'app-development': <Layers size={24} />
  };

  return icons[name];
}